export default __webpack_public_path__ + "static/media/fallimageh.38746af8.png";